import { PathRender } from "@visactor/vrender-core/render/symbol";

import { resolveContainerBinding } from "../../../common/explicit-binding";

import { MathPathPicker, MathPickerContribution } from "../constants";

import { DefaultMathPathPicker } from "./path-picker";

let loadPathPick = !1;

export function bindPathMathPickerContribution(container) {
    loadPathPick || (loadPathPick = !0, container.bind(MathPathPicker).toDynamicValue((() => new DefaultMathPathPicker(resolveContainerBinding(container, PathRender)))).inSingletonScope(), 
    container.bind(MathPickerContribution).toService(MathPathPicker));
}
//# sourceMappingURL=path-module.js.map
